// Thin async entry point required for Module Federation
import('./bootstrap')
// Thin async entry point required for Module Federation
import('./bootstrap')
